import { render, staticRenderFns } from "./About_WhoWeAre.vue?vue&type=template&id=a1ebb1a4&scoped=true&"
import script from "./About_WhoWeAre.vue?vue&type=script&lang=js&"
export * from "./About_WhoWeAre.vue?vue&type=script&lang=js&"
import style0 from "./About_WhoWeAre.vue?vue&type=style&index=0&id=a1ebb1a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ebb1a4",
  null
  
)

export default component.exports